import { CircularProgress, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@material-ui/core'
import useStyles from './styles'
import React, { useEffect } from 'react'
import { useUsuarioService } from 'hooks/useUsuarioService'
import { Autocomplete } from '@material-ui/lab'
import { useState } from 'react'
import { useCallback } from 'react'

export const FormPassagemCustodia = (props) => {
  const { form, handleChange, multiple, vestigios } = props

  const usuarioService = useUsuarioService()
  const [usuarios, setUsuarios] = useState([])
  const [processandoUsuarios, setProcessandoUsuarios] = useState(false)
  const classes = useStyles()

  const fetchUsuarios = useCallback(async () => {
    if (vestigios?.length) {
      setProcessandoUsuarios(true)
      const response = await usuarioService.listarUsuariosDeSetorAsync(vestigios[0].id_setor_atual)
      setUsuarios(response)
      setProcessandoUsuarios(false)
    }
  }, [vestigios])

  useEffect(() => {
    fetchUsuarios()
  }, [fetchUsuarios])

  return (
    <Grid container className={classes.container} spacing={3}>
      <Grid item md={12} sm={12} xs={12} lg={12}>
        <Typography className={classes.gridTitle}>
          <b>FORMULÁRIO DE PASSAGEM DE CUSTÓDIA</b>
        </Typography>
      </Grid>

      {processandoUsuarios ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <>
          {!multiple && (
            <>
              <Grid item md={12} sm={12} xs={12} lg={12}>
                <TextField
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  label="NÚMERO DO LACRE"
                  name="lacre"
                  onChange={(e) => handleChange('lacre', e.target.value)}
                  value={form.lacre}
                />
              </Grid>
              <Grid item container md={12} sm={12} xs={12} className={classes.fieldGroup}>
                <Grid item md={12} sm={12} xs={12}>
                  <Typography variant="body2">TIPO DA EMBALAGEM</Typography>
                </Grid>
                <FormControl component="fieldset" fullWidth>
                  <RadioGroup aria-label="tipo-embalagem" name="tipoEmbalagem" value={form.tipoEmbalagem || null} onChange={(e) => handleChange('tipoEmbalagem', e.target.value)} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <FormControlLabel value="SACO LACRE" control={<Radio />} label={<Typography variant="body2">SACO LACRE</Typography>} />
                    <FormControlLabel value="PLÁSTICO" control={<Radio />} label={<Typography variant="body2">PLÁSTICO</Typography>} />
                    <FormControlLabel value="ENVELOPE PAPEL" control={<Radio />} label={<Typography variant="body2">ENVELOPE DE PAPEL</Typography>} />
                    <FormControlLabel value="CAIXA" control={<Radio />} label={<Typography variant="body2">CAIXA</Typography>} />

                    <FormControlLabel value="AUSENTE" control={<Radio />} label={<Typography variant="body2">AUSENTE</Typography>} />
                    <FormControlLabel value="OUTRO" control={<Radio />} label={<Typography variant="body2">OUTRO</Typography>} />
                  </RadioGroup>
                </FormControl>
                {form.tipoEmbalagem === 'OUTRO' && (
                  <Grid item md={12} sm={12} xs={12}>
                    <TextField
                      label="OUTRO TIPO DE EMBALAGEM"
                      name="outroTipoEmbalagem"
                      variant="outlined"
                      value={form.outroTipoEmbalagem}
                      onChange={(e) => handleChange('outroTipoEmbalagem', e.target.value)}
                      disabled={form.tipoEmbalagem !== 'OUTRO'}
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                )}
              </Grid>
            </>
          )}
          <Grid item md={12} sm={12} xs={12}>
            <Autocomplete
              name="usuarioDestino"
              value={form.usuarioDestino}
              noOptionsText="Sem informações"
              options={usuarios}
              onChange={(event, newValue) => {
                handleChange('usuarioDestino', newValue)
              }}
              getOptionSelected={(option, value) => option.id === value || option === value}
              getOptionLabel={(option) => `${option.nome} ${option.cargo ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
              renderOption={(option) => `${option.nome} ${option.cargo ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="USUÁRIO DESTINO (MESMO SETOR)"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                />
              )}
            />
          </Grid>

          <Grid item md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              label="OBSERVAÇÕES"
              name="observacao"
              onChange={(e) => handleChange('observacao', e.target.value)}
              value={form.observacao}
              multiline
            />
          </Grid>
        </>
      )}
    </Grid>
  )
}
